import React, { useEffect, useContext, useState } from 'react';
import axios from "axios";
import { formatMoney } from "@shopify/theme-currency";
import ComponentProvider, { ComponentContext } from '../ComponentProvider';
import { BundleProgressBar, AddedBundleCard } from './'
import { useMediaQuery } from 'react-responsive';

export const BundleSummary = () => {
  const { bundleState } = useContext(ComponentContext);
  const [bundle, setBundle] = bundleState

  const [totalPrice, setTotalPrice] = useState(0)

  useEffect(() => {
    setTotalPrice(bundle.reduce((acc, curr) => acc + curr.variant.price, 0))
  }, [bundle])

  const handleCheckout = e => {
    e.preventDefault();
    axios
      .post("/cart/add.js", { items: [...bundle] })
      .then((response) => {
        window.location.href = '/checkout'
      })
      .catch(function (error) {
        console.log(error);
      });

  }

  const renderPlaceholders = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const maxPlaceholders = isMobile ? 3 : 6
    const placeholders = []
    const placeholderCount = bundle.length ? (maxPlaceholders - bundle.length) : maxPlaceholders
    for (var i = 0; i < placeholderCount; i++) {
      placeholders.push(<Placeholder key={`placeholder-${i}`} />);
    }
    return placeholders
  }

  const Placeholder = () => {
    return (
      <div className="Card Card--placeholder">
        <figure className='Card__figure'>

        </figure>
      </div>
    )
  }

  const renderItems = () => {
    return (
      <>
        {bundle.map(i => <AddedBundleCard key={i.id} item={i} />)}
      </>
    )
  }
  return (
    <>
      <div className="Section Section--bundle-checkout">
        <div className='Container'>
          <div className='inner'>
            <BundleProgressBar />
            <div>
              <button type="submit" disabled={!bundle.length} className="Button" onClick={handleCheckout}>
                Checkout: {formatMoney(totalPrice, theme.moneyFormat)}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="Section Section--bundle-summary">
        <div className='Container'>
          <div className='Section__content'>
            <div className='Loop'>
              {renderItems()}
              {renderPlaceholders()}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
